export default "__VITE_PUBLIC_ASSET__eb45c8fe__"